import { createSlice } from '@reduxjs/toolkit';
import { getDetailShopMenu } from './thunk';
import { normalizeMenuDetail } from '../../../helpers/menuAvailability';

export const initialState = {
    detailShopMenu: null,
    loading: {
        getDetailShopMenu: false,
    },
    success: {
        getDetailShopMenu: false,
    }
};

const DetailShopMenuSlice = createSlice({
    name: 'ShopMenuSlice',
    initialState,
    reducers: {
        clearState: (state) => {
            state.detailShopMenu = null;
            state.loading = {
                getDetailShopMenu: false,
            };
            state.success = {
                getDetailShopMenu: false,
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getDetailShopMenu.pending , (state) => {
            state.detailShopMenu = null;
            state.loading.getDetailShopMenu = true;
            state.success.getDetailShopMenu = false;
        });
        builder.addCase(getDetailShopMenu.fulfilled, (state, action) => {
            state.detailShopMenu = normalizeMenuDetail(action.payload.data);
            state.loading.getDetailShopMenu = false;
            state.success.getDetailShopMenu = true;
        });
        builder.addCase(getDetailShopMenu.rejected, (state, action) => {
            state.detailShopMenu = null;
            state.loading.getDetailShopMenu = false;
            state.success.getDetailShopMenu = false;
        });
    },
});

export const { clearState } = DetailShopMenuSlice.actions;
export default DetailShopMenuSlice.reducer;